export default {
    //쿠키 설정 name: 쿠키이름, value: 쿠키값, exp: 만료일
    // setCookie: function(name, value, exp) {
    //     var date = new Date();
    //     date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
    //     document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
    // },

    // //쿠키 얻기 name: 쿠키이름
    // getCookie: function(name) {
    //     var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    //     return value ? value[2] : null;
    // },

    // //쿠키 삭제 name: 쿠키이름
    // deleteCookie: function(name) {
    //     document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    // },

    setLocalStorage: function(name, value)
    {
        localStorage.setItem(name, value);
    },

    getLocalStorage: function(name, value)
    {
        return localStorage.getItem(name)
    },

    deleteLocalStorage: function(name)
    {
        localStorage.removeItem(name);
    },

    setLocalStorageWithExpire: function(name, value)
    {
        const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
        const data = {
            value,
            expire: today
        };
        localStorage.setItem(name, JSON.stringify(data));
    },

    getLocalStorageWithExpire: function(name)
    {
        const item = localStorage.getItem(name);
        if (!item) return null;

        try {
            const parsed = JSON.parse(item);
            const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

            if (parsed.expire === today) {
            return parsed.value;
            } else {
            return null;
            }
        } catch (e) {
            return null;
        }
    },

    deleteLocalStorageWithExpire: function(name)
    {
        localStorage.removeItem(name);
    },

    // 값 추가 또는 업데이트 함수
    updateOrAddValue: function (obj, key, newValue) {
        if (obj.hasOwnProperty(key)) {
            // 값이 이미 배열이면 push
            if (Array.isArray(obj[key])) {
                obj[key].push(newValue);
                console.log(`Appended value to key "${key}".`);
            } else {
                // 기존 값이 배열이 아니면 덮어쓰기
                obj[key] = [obj[key], newValue];
                console.log(`Converted existing value to array for key "${key}".`);
            }
        } else {
            // 키가 없으면 새 배열로 추가
            obj[key] = [newValue];
            console.log(`Added new key "${key}" with value in array.`);
        }
        // return obj;
    },
    // 키로 리스트 받아오는 함수
    getValueByKey: function (obj, key) {
        if (obj.hasOwnProperty(key)) {
            return obj[key];
        } else {
            console.log(`Key "${key}" not found.`);
            return null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/utilities/cookie.js